{#if $getMobileHoursView}
  {#each $getMobileHoursView as hourView}
    <div
      class="d-flex justify-content-between weather-mobile-card mb-2 align-items-center"
    >
      <div class="font-weight-bold">{hourView.time}</div>
      <div class="d-flex align-items-center">
        <div class="h2 font-weight-light m-0">{hourView.temperature} °C</div>
        <img
          class="weather-icon ml-4"
          src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{utils.getDisplayIcon(
            hourView.icon,
            hourView.time,
            hourView.sunriseHour,
            hourView.sunsetHour,
          )}.svg"
          alt="Delno oblačno"
        />
        <div class="marker-wind-direction ml-5" style="{hourView.wind}"></div>
        <div class="small ml-1 wind-number">{hourView.windSpeed}</div>
      </div>
    </div>
  {/each}
{/if}

<script lang="ts">
  import { weatherStore } from "../store";
  const { getMobileHoursView } = weatherStore;
  import { iconConverter } from "./../services/IconConverter";
  import { utils } from "../services/Utils";
</script>
